export const EDIT_FINANCIAL_ACCOUNT = 'EDIT_FINANCIAL_ACCOUNT';
export const DELETE_FINANCIAL_ACCOUNT = 'DELETE_FINANCIAL_ACCOUNT';
export const CREATE_FINANCIAL_ACCOUNT = 'CREATE_FINANCIAL_ACCOUNT';
export const LIST_FINANCIAL_ACCOUNT = 'LIST_FINANCIAL_ACCOUNT';